import { render, staticRenderFns } from "./TrainStations.vue?vue&type=template&id=5cfc886e&"
import script from "./TrainStations.vue?vue&type=script&lang=js&"
export * from "./TrainStations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports